import React from 'react';
import Icon from '../../../components/AppIcon';

const OrderSummaryCard = ({ items, totalPrice, services }) => {
  const itemCount = items?.filter(item => item?.serviceId)?.length;
  const serviceMap = new Map((services || []).map((s) => [s.id, s]));

  const getItemPrice = (item) => {
    const svc = item?.serviceId ? serviceMap.get(item.serviceId) : null;
    if (!svc) return 0;
    const base = Number(svc?.base_price || 0);
    const promo = Number(svc?.promotional_price || 0);
    const hasPromo = promo > 0 && promo < base;
    if (hasPromo) return promo;
    return base;
  };

  const getPromoMeta = (item) => {
    const svc = item?.serviceId ? serviceMap.get(item.serviceId) : null;
    if (!svc) return { hasPromo: false, base: 0, promo: 0, discount: 0 };
    const base = Number(svc?.base_price || 0);
    const promo = Number(svc?.promotional_price || 0);
    const hasPromo = promo > 0 && promo < base;
    return {
      hasPromo,
      base,
      promo,
      discount: hasPromo ? Math.max(0, base - promo) : 0,
    };
  };

  return (
    <div className="rounded-lg bg-card p-6 shadow-lg transition-all duration-300 hover:shadow-xl">
      <h2 className="mb-6 text-xl font-bold text-foreground">주문 요약</h2>
      <div className="space-y-4">
        <div className="flex items-center justify-between border-b border-border pb-3">
          <span className="text-sm text-muted-foreground">총 신발 수량</span>
          <span className="font-semibold text-foreground">{itemCount}켤레</span>
        </div>
        {items?.map((item, index) => {
          if (!item?.serviceId) return null;
          const svc = serviceMap.get(item.serviceId);
          const price = getItemPrice(item);
          const promoMeta = getPromoMeta(item);
          const showPromoPrice = promoMeta.hasPromo;
          return (
            <div key={item?.id} className="flex items-center justify-between">
              <div className="flex items-center space-x-2">
                <Icon name="CheckCircle2" size={16} color="var(--color-success)" />
                <span className="text-sm text-foreground">
                  신발 {index + 1} - {svc?.name || '-'}
                </span>
              </div>

              {showPromoPrice ? (
                <div className="text-right">
                  <p className="text-xs text-muted-foreground line-through">
                    {promoMeta.base?.toLocaleString('ko-KR')}원
                  </p>
                  <p className="text-sm font-semibold text-foreground">
                    {promoMeta.promo?.toLocaleString('ko-KR')}원
                  </p>
                  <p className="text-xs text-blue-700">
                    할인 {promoMeta.discount?.toLocaleString('ko-KR')}원
                  </p>
                </div>
              ) : (
                <span className="text-sm font-medium text-foreground">{price?.toLocaleString('ko-KR')}원</span>
              )}
            </div>
          );
        })}
        <div className="mt-6 flex items-center justify-between border-t border-border pt-4">
          <span className="text-lg font-bold text-foreground">총 결제 금액</span>
          <span className="text-2xl font-bold text-primary">{totalPrice?.toLocaleString('ko-KR')}원</span>
        </div>
      </div>
    </div>
  );
};

export default OrderSummaryCard;